import { useEffect, useState } from "react";

const UNITS: [number, string][] = [
	[60, "s"],
	[60, "m"],
	[24, "h"],
	[7, "d"],
	[4.35, "wk"],
	[12, "mo"],
	[Number.POSITIVE_INFINITY, "yr"],
];

export function formatRelativeTime(timestamp: number): string {
	const diff = Math.floor((Date.now() - timestamp) / 1000);
	if (diff < 10) return "now";
	if (diff < 60) return `${diff}s`;

	let val = diff;
	for (let i = 0; i < UNITS.length; i++) {
		const [div, label] = UNITS[i];
		if (val < div) return `${Math.floor(val)}${label}`;
		val /= div;
	}
	return `${Math.floor(val)}yr`;
}

export function useRelativeTime(timestamp: number) {
	const [text, setText] = useState(() => formatRelativeTime(timestamp));

	useEffect(() => {
		const update = () => setText(formatRelativeTime(timestamp));
		update();
		const id = setInterval(update, 30000); // update every 30s
		return () => clearInterval(id);
	}, [timestamp]);

	return text;
}
